// extracted by mini-css-extract-plugin
export default {"Buttons":"QuoteTermsButtons_Buttons__ghnn6","Buttons_declined":"QuoteTermsButtons_Buttons_declined__nkODK","Buttons_hidden":"QuoteTermsButtons_Buttons_hidden__B6TLi"};